import { render, staticRenderFns } from "./SpecialOccasionBanner.vue?vue&type=template&id=b5cca8fa"
import script from "./SpecialOccasionBanner.vue?vue&type=script&lang=js"
export * from "./SpecialOccasionBanner.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports